import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">常见问题</h2>
        <p className="section-subtitle">关于香蕉文化漫画网的常见疑问与解答</p>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 font-heading text-sm md:text-base font-bold text-foreground-950 list-none">
                <span className="pr-4">{item.question}</span>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-add-line group-open:hidden text-sm"></i>
                  <i className="ri-subtract-line hidden group-open:block text-sm"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}